import React, { useState } from "react";

const MultiSelect = (props) => {
  const [IsOpen, setIsOpen] = useState(false);
  const [SelectedOptions, setSelectedOptions] = useState([]);

  const toggleOptions = () => {
    if (IsOpen) {
      setIsOpen(false);
      document
        .getElementById(props.Id + "-chevron")
        .classList.remove("rotated-chevron");
    } else {
      setIsOpen(true);
      document
        .getElementById(props.Id + "-chevron")
        .classList.add("rotated-chevron");
    }
  };

  const toggleSelectOption = (Id) => {
    let Selected = [];
    if (document.getElementById(Id).classList.contains("active-option")) {
      document.getElementById(Id).classList.remove("active-option");
    } else {
      document.getElementById(Id).classList.add("active-option");
    }
    props.Options.map((Opt) => {
      if (
        document
          .getElementById(Opt.id + "-option")
          .classList.contains("active-option")
      ) {
        Selected.push(Opt);
      }
    });
    setSelectedOptions(Selected);
    props.SaveSelectedItems(Selected);
  };

  const deselectOptionItem = (Id, Opt) => {
    document.getElementById(Id).click();
    let SelectedItems = [...SelectedOptions];
    let IndexToRemove = SelectedItems.indexOf(Opt);
    SelectedItems.splice(IndexToRemove, 1);
    setSelectedOptions(SelectedItems);
    props.SaveSelectedItems(SelectedItems);
  };

  return (
    <div className="multi-select-wrapper">
      {IsOpen ? (
        <div className="outline" onClick={() => toggleOptions()}></div>
      ) : null}
      {SelectedOptions.length === 0 ? null : (
        <div className="selected-items">
          {SelectedOptions.map((Opt) => (
            <span className="small-chip">
              {Opt.name}
              <i
                className="feather-x"
                onClick={() => deselectOptionItem(Opt.id + "-option", Opt)}
              ></i>
            </span>
          ))}
        </div>
      )}
      <section className="select-trigger" onClick={() => toggleOptions()}>
        <p className="multi-select-placeholder">{props.Placeholder}</p>
        <i id={props.Id + "-chevron"} className="feather-chevron-down"></i>
      </section>

      <section className={IsOpen ? "options-wrapper" : "hidden"}>
        {props.Options.map((Opt) => (
          <span
            key={Opt.id}
            id={Opt.id + "-option"}
            className="option-item"
            onClick={() => toggleSelectOption(Opt.id + "-option")}
          >
            <span className="check-box">
              <i className="feather-check"></i>
            </span>
            <p className="option-name">{Opt.name}</p>
          </span>
        ))}
      </section>
    </div>
  );
};

export default MultiSelect;
